import { Pagination, Sort } from "@saleor/types";
import { stringifyQs } from "@saleor/utils/urls";

export const poUploadUrl = "/po-upload";
export const poUploadSettingsUrl = `${poUploadUrl}/settings`;

export enum FailedFilesListSortField {
  UPDATED_AT = "UPDATED_AT"
}

export type FailedFilesListSort = Sort<FailedFilesListSortField>;
export type FailedFilesListQueryParam = Pagination & FailedFilesListSort;

export const failedFilesListUrl = (params?: FailedFilesListQueryParam) =>
  poUploadUrl + "?" + stringifyQs(params);
